import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
import { AlertTriangle, XCircle } from 'lucide-react';
export function PainPointsSection() {
  const painPoints = ['Entras tarde por FOMO y te sacan en el retroceso', 'Después de una pérdida te cuesta parar', 'Operas demasiado por ansiedad o aburrimiento', 'Unos días eres “pro”, otros días te saboteas', 'Sabes qué hacer… pero bajo presión no lo haces'];
  return <Section background="darker" id="pain-points" data-id="element-105">
      <div className="text-center mb-12" data-id="element-106">
        <div className="inline-flex items-center justify-center p-3 bg-red-500/10 rounded-full mb-6" data-id="element-107">
          <AlertTriangle className="h-6 w-6 text-red-500" data-id="element-108" />
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-109">
          Si te pasa esto, estás en el lugar correcto
        </h2>
        <p className="text-slate-400 text-lg" data-id="element-110">
          ¿Te reconoces en alguna de estas situaciones?
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-111">
        {painPoints.map((point, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="bg-slate-900 border border-slate-800 p-6 rounded-xl hover:border-red-500/30 transition-colors group" data-id="element-112">
            <div className="flex items-start gap-4" data-id="element-113">
              <XCircle className="h-6 w-6 text-red-500 flex-shrink-0 mt-1 group-hover:scale-110 transition-transform" data-id="element-114" />
              <p className="text-slate-300 font-medium" data-id="element-115">{point}</p>
            </div>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      delay: 0.6
    }} className="mt-12 text-center" data-id="element-116">
        <p className="text-xl md:text-2xl font-semibold text-white" data-id="element-117">
          Entonces el problema no es tu estrategia:{' '}
          <span className="text-blue-500 underline decoration-blue-500/30 underline-offset-4" data-id="element-118">
            es tu ejecución.
          </span>
        </p>
      </motion.div>
    </Section>;
}